module.exports = __webpack_public_path__ + "static/media/grey_lines@3x.2025abd2.png";